import styled,{ css } from 'styled-components';
import { deviceHeight } from '../../designs/devices';

export const DrawerContent = styled.div`
  overflow-y: scroll;
  background-color:#FFFF;
  box-sizing:border-box;
`;

export const BottomDrawContainer = styled.div<{
    isDrawOpen: boolean;
    height:number;
    logout:boolean;
  }>`
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 200;
    box-sizing: border-box;
    transition: transform 0.1s;

    ${(props)=>
      props.logout &&
      css`
      height: ${props.height}px;
      `
    }

    @media (min-height:300px) { 
      ${(props)=>
        !props.logout &&
        css`
            height: 370px;
        `
      } 
    }
    
  @media ${deviceHeight.mobileXS} { 
    ${(props)=>
      !props.logout &&
      css`
          height: 470px;
      `
    } 
  }

  @media ${deviceHeight.mobileM} { 
    ${(props)=>
      !props.logout &&
      css`
         height: 530px;
      `
    } 
  }

  ${(props) =>
    !props.isDrawOpen &&
    css`
      transform: translateY(100%);`
  }
    ${DrawerContent} {
        height: calc(100% - 58px);
    }
`;

export const BottomDrawClose= styled.div`
position:fixed;
height:55px;
width:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-constent:flex-start;
`;

export const CLoseButton = styled.button`
width:47px;
height:47px;
border-radius:50%;
border:none;
outline:none;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
background-color:#F3F3F3;
`;

export const DrawHeader = styled.div`
position:static;
margin-top:55px;
width:100%;
height:58px;
background-color:#FFFF;
border-radius: 12px 12px 0px 0px;
display:flex;
flex-direction:column;
border-bottom: 1px solid #E8E8E8;
`;

export const HeaderLine = styled.div`
position:static;
display:flex;
margin-top:8px;
box-sizing:border-box;
width:10%;
margin-left:45%;
height:5.6px;
background: #E7ECF0;
border-radius: 3px;
`;

export const HeaderText = styled.span`
position:static;
margin-top:14px;
width:100%;
margin-left:4%;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 14px;
display: flex;
color: #303645;
`;

export const DrawerOverlay = styled.div<{ zIndex: number }>`
  width: 100vw;
  height: 100vh;
  opacity: 0.5;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  ${({ zIndex }) => css`
    z-index: ${zIndex && zIndex - 1};
    background-color: black;
  `}
`;

// ${(props)=>
//   props.logout &&
//   css`
//   height: ${props.height}px;
//   `
// }
// ${(props)=>
//   !props.logout &&
//   css`
//   height: calc(100% - ${props.height}px);
//   `
// }
